import { CustomRoleTranslator } from 'src/translators'
import { CustomRolesResponse } from 'src/types'
import { useCompanyRolesQuery } from 'src/types/generated'

export const useGetCustomRoles = () => {
  const { loading, data, error, refetch } = useCompanyRolesQuery()

  return {
    loading,
    customRoles:
      data && data.companyRoles
        ? // TODO: バックエンド側でnullを許容しないように出来ないか調整
          CustomRoleTranslator.toDetailEntities(data.companyRoles as CustomRolesResponse)
        : [],
    error,
    refetch,
  }
}
